// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_f8-a";
export var fulfillmentFormRail = "_f8-9";
export var headerTitleRow = "_f8-c";
export var orderDetailsWrapper = "_f8-7";
export var orderLinkTrigger = "_f8-2";
export var paymentInformationGrid = "_f8-h";
export var paymentSummaryColumn = "_f8-i";
export var shipmentContainer = "_f8-b";
export var shipmentDetailsMainPane = "_f8-8";
export var shipmentNavigationCard = "_f8-5";
export var shipmentNavigationRail = "_f8-3";
export var shipmentNavigationRailHeader = "_f8-4";
export var shipmentSummaryFact = "_f8-e";
export var shipmentSummaryGrid = "_f8-d";
export var shipmentSummaryMetadataRow = "_f8-f";
export var shipmentSummaryTags = "_f8-g";
export var shipmentWorkspace = "_f8-0";
export var shipmentWorkspaceContent = "_f8-6";
export var shipmentWorkspaceHeader = "_f8-1";